/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Component } from 'react'
import { Container } from 'flux/utils'
import HTML5Backend from 'react-dnd-html5-backend'
import { DragDropContext } from 'react-dnd'
import AppView from '../view/AppView'
import AppStore from '../store/AppStore'
import SessionStore from '../store/SessionStore'

class AppContainer extends Component {
  static getStores() {
    return [AppStore, SessionStore]
  }

  static calculateState(prevState, props) {
    return {
      app: AppStore.getState(),
      session: SessionStore.getState()
    }
  }

  render() {
    return AppView(this.state)
  }
}

export default DragDropContext(HTML5Backend)(Container.create(AppContainer))
